module.exports = `${require.publicPath}icon01.aeecd9c4.png`;